import Rellax from "rellax";

export function rellax() {
	if (document.querySelector('.rellax') !== null) {
		var rellax = new Rellax('.rellax', {
			center:true,
			speed: -1
		});
	}
}